import React, { useState, Fragment, useEffect } from "react";
import { STATES, API_BASE_URL } from "../../constants";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button, Grid, TextField, Select, MenuItem, FormHelperText, Modal, Box, Typography} from "@mui/material";
import TermsAndConditions from "../../components/TermsAndConditions/TermsAndConditionsSignup";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useGetDocumentsSignUpQuery } from "../../services/documentsApi";
import {useValidateUserInformationMutation} from "../../services/accountsApi";
import {useRegisterMutation} from "../../services/accountsApi";

const Signup = ({ setSendMail }) => {
  const [initRegister, {isLoading: registerIsLoading}] = useRegisterMutation();
  const { data: documents = [], isLoading: documentsLoading } = useGetDocumentsSignUpQuery();

  const [createAccountButtonDisabled, setCreateAccountButtonDisabled] = useState(true);
  const [checkmarkTermsOfService, setCheckmarkTermsOfService] = useState(false);
  const [openTermsAndConditionsModal, setOpenTermsAndConditionsModal] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptedDocumentIDs, setAcceptedDocumentIDs] = useState({});
  const [openAlert, setOpenAlert] = useState(false); 
  const [initValidateUserInfo, {isLoading: validateUserInfoIsLoading}] = useValidateUserInformationMutation();

  const handleClickAlert = () => {
    if (createAccountButtonDisabled) {
      setOpenAlert(true); 
    }
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  useEffect(() => {
    if (checkmarkTermsOfService) {
      setCreateAccountButtonDisabled(false);
    }
  }, [checkmarkTermsOfService]);

  const [loader, setLoader] = useState(false)

  const expression = {
    // user: /^[a-zA-Z0-9\s]{4,75}$/,
    user: {
      length: /^.{4,75}$/, 
      noSpecialCharacter: /^[a-zA-Z0-9\s]+$/
    },
    // name: /^[a-zA-ZÀ-ÿ\s]{1,75}$/,
    name: {
      length: /^.{1,75}$/,
      onlyLetters: /^[a-zA-ZÀ-ÿ\s]+$/ 
    },
    // password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/,
    password: {
      length: /.{8,75}/,
      lowerCase: /[a-z]/,
      upperCase: /[A-Z]/,
      number: /\d/,
      specialCharacter: /[$@$!%*?&]/
    },
    city: {
      length: /^.{3,75}$/, 
      noSpecialCharacter: /^[a-zA-Z0-9\s]+$/
    },
    Email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    num: /^\d{7,14}$/,
    mobilePhone: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    zip: /(^\d{5}$)|(^\d{5}-\d{4}$)/
  };

  const [formState, setFormState] = useState({
    formValues: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      screenName: '',
      password: '',
      confirmPassword: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      mobilePhone: ''
    },
    formErrors: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      screenName: '',
      password: '',
      confirmPassword: '',
      address1: '',
      city: '',
      state: '',
      zip: '',
      mobilePhone: ''
    }
  });

  let formatPhoneNumber = (str) => {
    //Filter only numbers from the input
    let cleaned = ("" + str).replace(/\D/g, "");

    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  const handleTermsOfService = () => {
    setOpenTermsAndConditionsModal(true); 
  };

  const handleDocumentAccept = (acceptedDocuments) => {
    setAcceptedDocumentIDs(acceptedDocuments)
    setCheckmarkTermsOfService(true);
    setAcceptTerms(true);
  };

  const handleModalOnClose = async () => {
    setOpenTermsAndConditionsModal(false)
  }

  function onChangeInput(e) {

    const { name, value } = e.target;
    setFormState(prevState => ({
      formValues: {
        ...prevState.formValues,
        [name]: value
      },
      formErrors: {
        ...prevState.formErrors,
        [name]: '' 
      }
    }));
    
  }

  function onBlurInput(e) {

    const { name, value } = e.target;
    let errorMessage = '';

    if (name === 'firstName') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        if (!expression.name.length.test(value)) {
          errorMessage = expression.name.length.test(value) ? '' : 'The field must contain at least one character';
        }
        else if (!expression.name.onlyLetters.test(value)) {
          errorMessage = expression.name.onlyLetters.test(value) ? '' : 'The field can only contain letters or spaces';
        }
      }
    }

    if (name === 'lastName') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        if (!expression.name.length.test(value)) {
          errorMessage = expression.name.length.test(value) ? '' : 'The field must contain at least one character';
        }
        else if (!expression.name.onlyLetters.test(value)) {
          errorMessage = expression.name.onlyLetters.test(value) ? '' : 'The field can only contain letters or spaces';
        }
      }
    }
  
    if (name === 'emailAddress') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        errorMessage = expression.Email.test(value) ? '' : <> Enter a valid Email <br /> Example: <br/> user@domain.com </>;
      }
    } 

    if (name === 'screenName') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }      
      else {
        if (!expression.user.length.test(value)) {
          errorMessage = expression.user.length.test(value) ? '' : 'The field must contain at least 4 characters';
        }
        else if (!expression.user.noSpecialCharacter.test(value)) {
          errorMessage = expression.user.noSpecialCharacter.test(value) ? '' : 'The field can only contain letters, numbers or spaces';
        }
      }

    }

    if (name === 'password') {

      if (!value.trim()) {
        errorMessage = 'This field is required';
      }

      else {

        const passwordError = [];

        if (!expression.password.length.test(value)) {
          passwordError.push('Between 8 and 75 characters');
        }
        if (!expression.password.lowerCase.test(value)) {
          passwordError.push('At least one lowercase letter (a-z)');
        }
        if (!expression.password.upperCase.test(value)) {
          passwordError.push('At least one uppercase letter (A-Z)');
        }
        if (!expression.password.number.test(value)) {
          passwordError.push('At least one number (0-9)');
        }
        if (!expression.password.specialCharacter.test(value)) {
          passwordError.push('At least one special character ($, @, !, %, *, ?, &)');
        }

        if (passwordError.length > 0) {
          errorMessage = (
            <>
              The password must contain: <br/>
              {passwordError.map((msg, index) => (
                <div key={index}>{msg}</div>
              ))}
            </>
          );
        }
      
      }

    }

    if (name === 'confirmPassword') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
    }

    if (name === 'address1') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        if (!expression.user.length.test(value)) {
          errorMessage = expression.user.length.test(value) ? '' : 'The field must contain at least 4 characters';
        }
        else if (!expression.user.noSpecialCharacter.test(value)) {
          errorMessage = expression.user.noSpecialCharacter.test(value) ? '' : 'The field can only contain letters, numbers or spaces';
        }      
      }
    }

    if (name === 'city') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        if (!expression.city.length.test(value)) {
          errorMessage = expression.city.length.test(value) ? '' : 'The field must contain at least 3 characters';
        }
        else if (!expression.city.noSpecialCharacter.test(value)) {
          errorMessage = expression.city.noSpecialCharacter.test(value) ? '' : 'The field can only contain letters, numbers or spaces';
        }      
      }
    }

    if (name === 'state') {
      errorMessage = value.trim() !== '' ? '' : 'This field is required';
    }

    if (name === 'zip') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        errorMessage = expression.zip.test(value) ? '' : <> Enter a valid ZIP <br/> Example: <br/> 12345 <br/> 12345-6789 </>;
      }
    }

    if (name === 'mobilePhone') {
      if (!value.trim()) {
        errorMessage = 'This field is required';
      }
      else {
        errorMessage = expression.mobilePhone.test(value) ? '' : <> Enter a valid Mobile Phone <br/> Example: <br/> 1234567890 <br/> (123) 456-7890 </>;
      }
    }

    if (name === 'confirmPassword' && value !== formState.formValues.password) {
      errorMessage = 'Your passwords must match';
    }

    if ((name === 'password' || name === 'screenName') && formState.formValues.password) {
      if (formState.formValues.password === formState.formValues.screenName) {
        errorMessage = 'The password cannot contain your screenName';
      }
    }
  
    setFormState(prevState => ({
      ...prevState,
      formErrors: {
        ...prevState.formErrors,
        [name]: errorMessage
      }
    }));

  }

  const validateInput = () => {
    
    const { firstName, lastName, emailAddress, screenName, password, confirmPassword, address1, city, state, zip, mobilePhone } = formState.formValues;
    let errors = {};
  
    let formErrors = {
      firstName: '',
      lastName: '',
      emailAddress: '',
      screenName: '',
      password: '',
      confirmPassword: '',
      address1: '',
      city: '',
      state: '',
      zip: '',
      mobilePhone: ''
    };

    const passwordError = [];

    if (!firstName.trim()) {
      formErrors.firstName = 'This field is required';
      errors.firstName = formErrors.firstName;
    }
    else {
      if (!expression.name.length.test(firstName)) {
        formErrors.firstName = 'The field must contain at least one character';
        errors.firstName = formErrors.firstName;
      }
      else if (!expression.name.onlyLetters.test(firstName)) {
        formErrors.firstName = 'The field can only contain letters or spaces';
        errors.firstName = formErrors.firstName;
      }
    }

    if (!lastName.trim()) {
      formErrors.lastName = 'This field is required';
      errors.lastName = formErrors.lastName;
    }
    else {
      if (!expression.name.length.test(lastName)) {
        formErrors.lastName = 'The field must contain at least one character';
        errors.lastName = formErrors.lastName;
      }
      else if (!expression.name.onlyLetters.test(lastName)) {
        formErrors.lastName = 'The field can only contain letters or spaces';
        errors.lastName = formErrors.lastName;
      }
    }
  
    if (!emailAddress.trim()) {
      formErrors.emailAddress = 'This field is required';
      errors.emailAddress = formErrors.emailAddress;
    }
    else if (!expression.Email.test(emailAddress)) {
      formErrors.emailAddress = <> Enter a valid Email <br /> Example: <br/> user@domain.com </>;
      errors.emailAddress = formErrors.emailAddress;
    }
  
    if (!screenName.trim()) {
      formErrors.screenName = 'This field is required';
      errors.screenName = formErrors.screenName;
    }
    else {
      if (!expression.user.length.test(screenName)) {
        formErrors.screenName = 'The field must contain at least 4 characters';
        errors.screenName = formErrors.screenName;      
      }
      else if (!expression.user.noSpecialCharacter.test(screenName)) {
        formErrors.screenName = 'The field can only contain letters, numbers or spaces';
        errors.screenName = formErrors.screenName;
      }
    }

    if (!password.trim()) {
      formErrors.password = 'This field is required';
      errors.password = formErrors.password;
    }

    else {

      if (!expression.password.length.test(password)) {
        passwordError.push('Between 8 and 75 characters');
      }

      if (!expression.password.lowerCase.test(password)) {
        passwordError.push('At least one lowercase letter (a-z)');
      }

      if (!expression.password.upperCase.test(password)) {
        passwordError.push('At least one uppercase letter (A-Z)');
      }

      if (!expression.password.number.test(password)) {
        passwordError.push('At least one number (0-9)');
      }

      if (!expression.password.specialCharacter.test(password)) {
        passwordError.push('At least one special character ($, @, !, %, *, ?, &)');
      }

      if (passwordError.length > 0) {
        errors.password = (
          <>
            The password must contain: <br/>
            {passwordError.map((msg, index) => (
              <div key={index}>{msg}</div>
            ))}
          </>
        );
      }

    }

    if (password && screenName && password === screenName) {
      formErrors.password = 'The password cannot contain your screenName';
      errors.password = formErrors.password;
    }

    if (!confirmPassword.trim()) {
      formErrors.confirmPassword = 'This field is required';
      errors.confirmPassword = formErrors.confirmPassword;
    }
    else if (password !== confirmPassword) {
      formErrors.confirmPassword = 'Your passwords must match';
      errors.confirmPassword = formErrors.confirmPassword;
    }

    if (!address1.trim()) {
      formErrors.address1 = 'This field is required';
      errors.address1 = formErrors.address1;
    }
    else {
      if (!expression.user.length.test(address1)) {
        formErrors.address1 = 'The field must contain at least 4 characters';
        errors.address1 = formErrors.address1;      
      }
      else if (!expression.user.noSpecialCharacter.test(address1)) {
        formErrors.address1 = 'The field can only contain letters, numbers or spaces';
        errors.address1 = formErrors.address1;
      }
    }

    if (!city.trim()) {
      formErrors.city = 'This field is required';
      errors.city = formErrors.city;
    }
    else {
      if (!expression.city.length.test(city)) {
        formErrors.city = 'The field must contain at least 3 characters';
        errors.city = formErrors.city;      
      }
      else if (!expression.city.noSpecialCharacter.test(city)) {
        formErrors.city = 'The field can only contain letters, numbers or spaces';
        errors.city = formErrors.city;
      }
    }

    if (!zip.trim()) {
      formErrors.zip = 'This field is required';
      errors.zip = formErrors.zip;
    }
    else if (!expression.zip.test(zip)) {
      formErrors.zip = <> Enter a valid ZIP <br/> Example: <br/> 12345 <br/> 12345-6789 </>;
      errors.zip = formErrors.zip;
    }

    if (!expression.user.length.test(state)) {
      formErrors.state = 'This field is required';
      errors.state = formErrors.state;
    }

    if (!mobilePhone.trim()) {
      formErrors.mobilePhone = 'This field is required';
      errors.mobilePhone = formErrors.mobilePhone;
    }
    else if (!expression.mobilePhone.test(mobilePhone)) {
      formErrors.mobilePhone = <> Enter a valid Mobile Phone <br/> Example: <br/> 1234567890 <br/> (123) 456-7890 </>;
      errors.mobilePhone = formErrors.mobilePhone;
    }

    if (password !== confirmPassword) {
      formErrors.confirmPassword = 'Your passwords must match';
      errors.confirmPassword = formErrors.confirmPassword;
    }
  
    setFormState(prevState => ({
      ...prevState,
      formErrors: {
        ...prevState.formErrors,
        ...errors,
      },
    }));
  
    return Object.values(errors).every(error => error === '');
  };

  const validateUserInformation = async (screenName, email) => {

    try {
      const result = await initValidateUserInfo({screenName:screenName, email:email}).unwrap();
      console.log(result);
      return result;
    } 
    catch (error) {
      console.error("Error: ", error);
      return false;
    }

  };

  const submit = async (e) => {

    e.preventDefault();

    if (validateInput()) {

      const validateInformation = await validateUserInformation(formState.formValues.screenName, formState.formValues.emailAddress);

      if (validateInformation.isValid) {

    setLoader(true)
    
    let mobile = formatPhoneNumber(formState.formValues.mobilePhone);

    const body = {
      screenName: formState.formValues.screenName,
      FirstName: formState.formValues.firstName,
      LastName: formState.formValues.lastName,
      MobilePhone: mobile,
      Address1: formState.formValues.address1,
      Address2: formState.formValues.address2,
      City: formState.formValues.city,
      State: formState.formValues.state,
      Zip: formState.formValues.zip,
      Email: formState.formValues.emailAddress,
      Password: formState.formValues.password,
      ConfirmPassword: formState.formValues.confirmPassword,
      acceptTerms: acceptTerms,
      acceptedDocumentTypeIDs: acceptedDocumentIDs
    }

    await initRegister(body)
      .unwrap()
      .then((result) => {
        console.log(result)
        if (result.message !== undefined) {
          console.log("Ok");
          setSendMail({
            status: true,
            value: formState.formValues.emailAddress
          })
        } else {
          for (const property in ((result.errors || []))) {
            let func = "set" + property;
            eval(func)({ error: "false" })

            setLoader(false)
          }
        }
      })
      .catch((error) => console.log(error));

    }

    else {
      setFormState(prevState => ({
        formValues: { ...prevState.formValues },
        formErrors: {
          ...prevState.formErrors,
          emailAddress: validateInformation.errors.email || '',
          screenName: validateInformation.errors.screenName || '',
        }
      }));
    }
    setLoader(false)
  }

  };

  return (
    <Fragment>

      <TermsAndConditions open={openTermsAndConditionsModal} handleClose={handleModalOnClose} documents={documents}  onDocumentAccept={handleDocumentAccept} />

      <form onSubmit={submit} className="formLogin">

        <div className="sign-up-form">

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>First Name</label>
              <TextField
                name="firstName"
                value={formState.formValues.firstName}
                onChange={onChangeInput}
                error={!!formState.formErrors.firstName}
                helperText={formState.formErrors.firstName ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.firstName}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.firstName && "1.5px solid red"}}}
                inputProps = {{ maxLength: 75 }}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Last Name</label>
              <TextField
                name="lastName"
                value={formState.formValues.lastName}
                onChange={onChangeInput}
                error={!!formState.formErrors.lastName}
                helperText={formState.formErrors.lastName ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.lastName}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em",  border: formState.formErrors.lastName && "1.5px solid red"}}}
                inputProps = {{ maxLength: 75 }}
              />
            </Grid>
          </Grid>

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Preferred Screen Name</label>
              <TextField
                name="screenName"
                value={formState.formValues.screenName}
                onChange={onChangeInput}
                error={!!formState.formErrors.screenName}
                helperText={formState.formErrors.screenName ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.screenName}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.screenName && "1.5px solid red"}}}
                inputProps = {{ maxLength: 75 }}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Email Address</label>
              <TextField
                name="emailAddress"
                value={formState.formValues.emailAddress}
                onChange={onChangeInput}
                error={!!formState.formErrors.emailAddress}
                helperText={formState.formErrors.emailAddress ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.emailAddress}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.emailAddress && "1.5px solid red"}}}
                inputProps = {{ maxLength: 75 }}
              />
            </Grid>
          </Grid>

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Password</label>
              <TextField
                type="password"
                name="password"
                value={formState.formValues.password}
                onChange={onChangeInput}
                error={!!formState.formErrors.password}
                helperText={formState.formErrors.password ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.password}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", height:'2.5em', border: formState.formErrors.password && "1.5px solid red"}}}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Confirm Password</label>
              <TextField
                type="password"
                name="confirmPassword"
                value={formState.formValues.confirmPassword}
                onChange={onChangeInput}
                error={!!formState.formErrors.confirmPassword}
                helperText={formState.formErrors.confirmPassword ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.confirmPassword}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", height:'2.5em', border: formState.formErrors.confirmPassword && "1.5px solid red"}}}
              />
            </Grid>
          </Grid>

          <div className="divisor" style={{ marginBottom: '3em' }}></div>

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Address 1</label>
              <TextField
                name="address1"
                value={formState.formValues.address1}
                onChange={onChangeInput}
                error={!!formState.formErrors.address1}
                helperText={formState.formErrors.address1 ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.address1}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.address1 && "1.5px solid red"}}}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Address 2</label>
              <TextField
                name="address2"
                value={formState.formValues.address2}
                onChange={onChangeInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em"} }}
              />
            </Grid>
          </Grid>

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>City</label>
              <TextField
                name="city"
                value={formState.formValues.city}
                onChange={onChangeInput}
                error={!!formState.formErrors.city}
                helperText={formState.formErrors.city ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.city}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.city && "1.5px solid red"}}}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label id="select-state-label">State</label>
              <Select
                name = "state"
                value={formState.formValues.state}
                onChange={onChangeInput}
                error={!!formState.formErrors.state}
                helperText={formState.formErrors.state ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.state}</span>) : ' '}
                onBlur={onBlurInput}
                style={{ backgroundColor: "#fff",  borderRadius: "0.5em", height: "2.5em", border: formState.formErrors.state ? "1.5px solid red" : "none"}}
                MenuProps={
                  { sx: { maxHeight: "30vh" } } 
                }
              >
                {STATES.map((option) => (
                  <MenuItem key={option.abbreviation} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formState.formErrors.state ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.state}</span>) : ' '}</FormHelperText>
            </Grid>
          </Grid>

          <Grid container style={{ justifyContent: 'center' }} spacing={2}>
            <Grid item xs={12} sm={6} container direction="column">
              <label>ZIP</label>
              <TextField
                name="zip"
                value={formState.formValues.zip}
                onChange={onChangeInput}
                error={!!formState.formErrors.zip}
                helperText={formState.formErrors.zip ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.zip}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.zip && "1.5px solid red"}}}
              />
            </Grid>
            <Grid item xs={12} sm={6} container direction="column">
              <label>Mobile Phone</label>
              <TextField
                name="mobilePhone"
                value={formState.formValues.mobilePhone}
                onChange={onChangeInput}
                error={!!formState.formErrors.mobilePhone}
                helperText={formState.formErrors.mobilePhone ? (<span style={{ color: 'black', listStyleType: 'circle' }}>&bull; {formState.formErrors.mobilePhone}</span>) : ' '}
                onBlur={onBlurInput}
                InputProps={{ style: {backgroundColor: "#fff", borderRadius: "0.5em", border: formState.formErrors.mobilePhone && "1.5px solid red"}}}
              />
            </Grid>
          </Grid>
     
        </div>
        
        <div className="boxTerm" style={{ wordBreak: 'break-word', flexWrap: 'wrap', margin: '2em 0 0 0' }}>
          <span style={{ whiteSpace: 'nowrap' }}>
          Sign the
          </span>
          <Button
            onClick={handleTermsOfService} 
            style={{backgroundColor: 'white', margin: '0 0.5em 0 0.5em'}}
          >
            Terms of Service
            {checkmarkTermsOfService && <CheckOutlinedIcon style={{ color: 'green', marginLeft: '0.25em'}}/>}
          </Button>          
          <span>
          and read the
            </span>
          <Button
            style={{backgroundColor: 'white', margin: '0 0.5em 0 0.5em'}}
            href = "https://www.encorehive.com/privacy-policy" target="_blank" rel="noreferrer"
          >
            Privacy Policy
          </Button>
          <span>
            to complete registration.  
          </span>
        </div>

        <div style={{ margin: '2em 0' }} onClick={handleClickAlert}>
          {!loader ? <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={createAccountButtonDisabled}
          >
            Create Account
          </Button>
            :
            <CircularProgress />
          }
        </div>

      </form>
      
      <Modal open={openAlert}>
        <Box 
          sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 750, backgroundColor: '#FFFFFF', borderRadius: '2em', padding:'1em' }}
        >
          <InfoOutlinedIcon sx={{ color: 'var(--orange)', fontSize: '32px', width: '100%' }} />  
          <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '700', color: 'var(--orange)' }} align="center" > 
            To successfully complete the registration, you must read and accept all documents displayed by clicking the Terms Of Service button.
          </Typography>
          <div className='basic-modal-button'>
            <Button variant='contained' style={{ width: '100px' }} onClick={handleCloseAlert}>Accept</Button>
          </div>
        </Box>
      </Modal>

    </Fragment>
  );
};
export default Signup;
